export type HelixSearchV2InsightSize = 'default' | 'compact' | 'micro'

export const HELIX_INSIGHT_SIZE_STYLES: Record<
    HelixSearchV2InsightSize,
    { container: string; label: string; value: string }
> = {
    default: {
        container: 'flex-1 min-w-[150px] max-w-[220px] h-28 p-3',
        label: 'text-base',
        value: 'text-2xl',
    },
    compact: {
        container: 'flex-1 min-w-0 p-2',
        label: 'text-sm',
        value: 'text-lg',
    },
    micro: {
        container: 'flex-1 min-w-0 p-1',
        label: 'text-xs',
        value: 'text-lg',
    },
}
